<div class="chat-container">
<div #messagesContainer class="messages-container">
    @for (message of messages(); track message.timestamp+message.author) {
        @switch (message.author) {
            @case ('user') {
                <app-user-message class="user-message" [message]="message"></app-user-message>
            }
            @case ('assistant') {
                <app-copilot-message class="copilot-message" [message]="message" [sendMessage]="this.chatId()"></app-copilot-message>
            }
        }
    }
  <div #scrollAnchor></div>
</div>
  <div class="prompt-bar-container">
<app-copilot-prompt-bar class="prompt-bar" [promptControl]="promptControl" (sendMessage)="onSendMessage($event)" [maxHeight]="312"></app-copilot-prompt-bar>
  <div class="copilot-brand-selection" *ngIf="myBrand">
    <app-two-stage-brand-picker
      [placeholderText]="'Select brands for tailored answers'"
      [competitorSelectionText]="'Select competitors for comparison'"
      [myBrand]="myBrand"
      [myCompetitors]="myCompetitors"
    >
    </app-two-stage-brand-picker>
  </div>
</div>
